import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { GetWidgetsService } from '../../get-widgets.service';
import { NotificationsService } from 'angular2-notifications';
import { Subscription } from 'rxjs/Subscription';
import { MatDialog } from '@angular/material/dialog';import { SearchFilters } from '../../../dashboard/search-panel/search-panel.model';

@Component({
  selector: 'app-cost-per-hour-widget',
  templateUrl: './cost-per-hour-widget.component.html',
  styleUrls: ['./cost-per-hour-widget.component.scss']
})
export class CostPerHourWidgetComponent implements OnInit {
  dataSource: any;
  width: number = 350;
  height: number = 180;
  type = "scrollbar2d";
  dataFormat = "json";
  subscriptions: Subscription[] = [];
  isInPopup: boolean = false;
  noData: boolean = false;
  loading: boolean = true;
  // Search Parameters
  @Input() searchParameters: SearchFilters = new SearchFilters();

  constructor(private _widgets: GetWidgetsService,
    private _notification: NotificationsService,
    private _dialog: MatDialog) {
    this.dataSource = {
      chart: {
        // caption: "Budget Performance against Budget",
        // xaxisname: "Bucket",
        // yaxisname: "hrs",

        plottooltext:
          "<b>$label</b> was <b>$dataValue</b>",
        theme: "fusion",
        // labelDisplay: "rotate",
        plotSpacePercent: '50',
        alignCaptionWithCanvas: "0"
      },
      categories: [
        {
          category: []
        }
      ],
      dataset: [
        {
              data: []
          
        }
      ]
    };




  }

  ngOnInit() {
    var params: SearchFilters = {
      customer: this.searchParameters.customer,
      jobsite: this.searchParameters.jobsite,
      equipment: this.searchParameters.equipment,
      make: this.searchParameters.make,
      makeUC: this.searchParameters.makeUC,

      model: this.searchParameters.model,
      implement: this.searchParameters.implement,
      ImplementTypes: this.searchParameters.ImplementTypes,
      ComponentTypes: this.searchParameters.ComponentTypes,

      onEq: this.searchParameters.onEq,
      evalA: false,
      evalB: false,
      evalC: false,
      evalX: false,
      NoImps: false,
      family: this.searchParameters.family,
      assetSerial: this.searchParameters.assetSerial,
      GETType: this.searchParameters.GETType,
      PageNumber: 0,
      PageSize: 0
    };

    this._widgets.GetCostPerHourWidgetData(params).subscribe(res => {
      console.log("data__", res)


      this.loading=false;

      if (res.JobsiteLits != null || res.JobsiteLits.length > 0) {
        this.dataSource.categories[0].category = res.JobsiteLits;
        this.dataSource.dataset[0].data = res.costperhrsList;
        this.loading = false;
      }else{
        this.loading = true;
        this.noData=true;
      }
      

     
    })
  }

}
